import { ThunkAction, Action, combineReducers } from "@reduxjs/toolkit";

import authReducer from "shared/reducers/authReducer";
import {
  usersReducer,
  // patientsReducer,
  labsReducer,
  accessionPrefixesReducer,
  labStationsReducer,
  labClinicsReducer,
  clinicsReducer,
  // casesReducer,
  // accessionsReducer as frontLoadAccessionsReducer,
  // workProcessesReducer,
  // workProcessTasksReducer,
  stainsReducer,
  labStainsReducer,
  externalLabsReducer,
  externalLabStainsReducer,
  labPanelsReducer,
  antigenRetrievalMethodsReducer,
  antibodySpeciesReducer,
} from "shared/reducers/frontLoaderReducers";
import passwordResetConfirm from "shared/reducers/passwordResetConfirmReducer";
import passwordReset from "shared/reducers/passwordResetReducer";
import requestStatuses from "shared/reducers/requestStatusesReducer";
import sysReducer from "shared/reducers/sysReducer";
import configurePWStore from "shared/utils/configurePWStore";

import accessionReducer from "./reducers/accessionReducer";
import { AdminCaseReducer } from "./reducers/admin/reducers/caseReducer";
import { AdminPatientReducer } from "./reducers/admin/reducers/patientReducer";
import { AdminSlidesReducer } from "./reducers/admin/reducers/slidesReducer";
import { AdminSpecimensReducer } from "./reducers/admin/reducers/specimensReducer";
import { barcodeBadgeReducer } from "./reducers/barcodeBadgeReducer";
import caseReducer from "./reducers/caseReducer";
import casesWithWorkReducer from "./reducers/casesWithWorkReducer";
import blockMetaReducer from "./reducers/meta/blockMetaReducer";
import shipmentReducer from "./reducers/shipmentReducer";
import shipmentsReducer from "./reducers/shipmentsReducer";
import accessioningReducer from "./reducers/ui/accessioningReducer";
import interfaceReducer from "./reducers/ui/interfaceReducer";
import printReducer from "./reducers/ui/printReducer";
import stationDocumentReducer from "./reducers/ui/stationDocumentReducer";
import rootSaga from "./sagas/rootSaga";

const rootReducer = combineReducers({
  accession: accessionReducer,
  case: caseReducer,
  casesWithWork: casesWithWorkReducer,
  auth: authReducer,
  sys: sysReducer,
  passwordReset: passwordReset,
  passwordResetConfirm: passwordResetConfirm,
  ui: combineReducers({
    interface: interfaceReducer,
    accessioning: accessioningReducer,
    print: printReducer,
    stationDocument: stationDocumentReducer,
  }),
  requestStatuses,
  users: usersReducer,
  // patients: patientsReducer,
  labs: labsReducer,
  accessionPrefixes: accessionPrefixesReducer,
  labStations: labStationsReducer,
  clinics: clinicsReducer,
  labClinics: labClinicsReducer,
  // cases: casesReducer,
  // accessions: frontLoadAccessionsReducer,
  // workProcesses: workProcessesReducer,
  // workProcessTasks: workProcessTasksReducer,
  stains: stainsReducer,
  labStains: labStainsReducer,
  externalLabs: externalLabsReducer,
  externalLabStains: externalLabStainsReducer,
  labPanels: labPanelsReducer,
  antigenRetrievalMethods: antigenRetrievalMethodsReducer,
  antibodySpecies: antibodySpeciesReducer,
  admin: combineReducers({
    case: AdminCaseReducer,
    patient: AdminPatientReducer,
    slides: AdminSlidesReducer,
    specimens: AdminSpecimensReducer,
  }),
  barcodeBadges: barcodeBadgeReducer,
  shipments: shipmentsReducer,
  shipment: shipmentReducer,
  meta: combineReducers({
    blocks: blockMetaReducer,
  }),
});

export const store = configurePWStore({
  rootReducer,
  rootSaga,
  ignoredStatePaths: [
    // "patients",
    // "cases",
    "accessions",
    // "workProcesses",
    // "workProcessTasks",
  ],
});

export default store;

export type RootState = ReturnType<typeof rootReducer>;
export type ApplicationState = RootState;
export type AppDispatch = typeof store.dispatch;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
